export default __webpack_public_path__ + "static/hero-e352821f097af44e134ba05180605b96.svg";